<template>
    <layout-card
        :error="error"
        :loading="loading"
        :isCustomizable="settings.isCustomizable"
        class="card-opportunity"
        @hide-card="$emit('hide-card', type)"
        @edit-card="toggleSettingsForm"
        @refresh-card="fetchCard(type, {}, true)"
    >
        <template #title>
            {{ name }}
        </template>
        <template #actions>
            <CompassIconButton
                v-if="settings.canCreate"
                icon="plus"
                onclick="Opportunity.addOpportunity()"
            />
        </template>
        <template #content>
            <template-kpi-card :data="{ stats: cardData, labels: labels }" />

            <Teleport to="#dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </Teleport>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import TemplateKpiCard from './TemplateKpiCard.vue';
import CardMixin from './CardMixin.js';

export default {
    components: {
        LayoutCard,
        TemplateKpiCard,
    },
    mixins: [CardMixin],
    data() {
        return {
            labels: {
                month: {
                    label: this.$l10n.__('À échéance ce mois'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
                week: {
                    label: this.$l10n.__('À échéance cette semaine'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
                open: {
                    label: this.$l10n.__('Ouverte'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
                late: {
                    label: this.$l10n.__('En retard'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
            },
            settingsFormName: 'opportunity-setting-form',
        };
    },
};
</script>
